import { StringQ } from "@pdfking/structs"

import type { AnyGUID, StringGUID } from "#public"

/**
 * Converts a GUID to its string representation.
 * If already a string, returns as-is. Otherwise converts bigint to base-36 string.
 *
 * @param guid - GUID as either bigint or string
 * @returns String representation in base-36 format
 *
 * @example
 * ```ts
 * import { GuidToString, UUID } from "@pdfking/tfunc"
 *
 * GuidToString(UUID()) // its base-36 string, e.g. "3h0tsjg9t7viycucd2d2pcr1"
 * GuidToString("abc123") // "abc123" (unchanged)
 * ```
 */
export const GuidToString = (guid: AnyGUID): StringGUID =>
  StringQ(guid) ? guid : (guid.toString(36) as StringGUID)
